/**
 * Created by az on 2017/7/12.
 */
import QbButton from './QbButton';

export default QbButton;